import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useState } from "react";

const DisclaimerContext = createContext();

export const useDisclaimer = () => {
    const context = useContext(DisclaimerContext);
    if (!context) {
        throw new Error("useDisclaimer must be used within a DisclaimerProvider");
    }
    return context;
};

export const DisclaimerProvider = ({ children }) => {
    /// TODO: remove this provider when the disclaimer is no longer needed.
    // This was originally intended to be shown globally, but since multiple apps like vision, backoffice, etc. reference the homepage through iframes, this will only be shown on the root route ("/").
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const router = useRouter();

    // Check if disclaimer was already accepted on mount
    useEffect(() => {
        const disclaimerAccepted = localStorage.getItem("disclaimerAccepted");
        // Only show the disclaimer on the homepage
        const showDisclaimer = router.pathname === "/" && disclaimerAccepted !== "true";
        if (showDisclaimer) {
            setShowDisclaimer(true);
        }
    }, []);

    const acceptDisclaimer = () => {
        localStorage.setItem("disclaimerAccepted", "true");
        setShowDisclaimer(false);
    };

    const showDisclaimerDialog = () => {
        setShowDisclaimer(true);
    };

    const hideDisclaimerDialog = () => {
        setShowDisclaimer(false);
    };

    const value = {
        showDisclaimer,
        acceptDisclaimer,
        showDisclaimerDialog,
        hideDisclaimerDialog,
    };

    return <DisclaimerContext.Provider value={value}>{children}</DisclaimerContext.Provider>;
};
